export const listPages = /* GraphQL */ `
  query ListPagesByPageId(
    $pageId: ID
    $sort: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPagesByPageId(
      pageId: $pageId
      sort: $sort
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        status
        createdAt
        updatedAt
        title
        slug
        # description
        eyebrow
        headline
        body
        inlineBody
        ctaText
        ctaLink
        headlineLow
        bodyLow
        layout
        pageId
        local
        publishedAt
        image
        sort
        meta
        pages {
          items {
            id
            label
            status
            createdAt
            updatedAt
            title
            slug
            # description
            eyebrow
            headline
            body
            inlineBody
            ctaText
            ctaLink
            headlineLow
            bodyLow
            layout
            pageId
            local
            publishedAt
            image
            sort
            meta
            pages {
              items {
                id
                slug
                title
                pageId
              }
            }
            referencedQuicklinks {
              items {
                id
                pageId
                createdAt
                updatedAt
                page {
                  id
                  slug
                  pageId
                  title
                  layout
                }
              }
            }
          }
        }
        referencedQuicklinks {
          items {
            id
            pageId
            createdAt
            updatedAt
            page {
              id
              slug
              pageId
              title
              layout
            }
          }
        }
      }
      nextToken
    }
  }
`;
